import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { BookOpen, Calendar, Cloud, Camera } from "lucide-react";
import SharedNavbar from './SharedNavbar';

const features = [
  {
    icon: BookOpen,
    titleKey: "features.catalog.title",
    descriptionKey: "features.catalog.description",
    color: "from-emerald-500 to-green-600",
  },
  {
    icon: Calendar,
    titleKey: "features.calendar.title",
    descriptionKey: "features.calendar.description",
    color: "from-blue-500 to-cyan-600",
  },
  {
    icon: Cloud,
    titleKey: "features.weather.title",
    descriptionKey: "features.weather.description",
    color: "from-purple-500 to-indigo-600",
  },
  {
    icon: Camera,
    titleKey: "features.tracking.title",
    descriptionKey: "features.tracking.description",
    color: "from-orange-500 to-red-600",
  },
];

const Features: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SharedNavbar />
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
                {t('features.title')}
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                {t('features.subtitle')}
              </p>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {features.map((feature, index) => (
                <Card
                  key={index}
                  className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-white"
                >
                  <CardHeader className="text-center pb-4">
                    <div
                      className={`w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br ${feature.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}
                    >
                      <feature.icon className="w-8 h-8 text-white" />
                    </div>
                    <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-emerald-700 transition-colors">
                      {t(feature.titleKey)}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-gray-600 text-center leading-relaxed">
                      {t(feature.descriptionKey)}
                    </CardDescription>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Features; 